export const text = {
  title: 'Create Account',
  subtitle: 'Sign up to get started',
  submit: 'Sign Up',
  loginPrompt: 'Already have an account? ',
  loginAction: 'Sign in',
  success: 'Signed up successfully!',
  invalidPassword: 'Invalid password. Please try again.',
  error: 'Could not sign up, did you mean to sign in?',
};
